import CreateTicket from '../pages/CreateTicket'
import ErrorPage from '../pages/ErrorPage'
import Login from '../pages/Login'
import Home from '../pages/Home'
import MainLayout from '../layouts/MainLayout'
import Settings from '../pages/Settings'
import Tickets from '../pages/tickets'
import HelpRoute from './HelpRoute'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ViewTicket from '../pages/ViewTicket'
import MyTickets from '../pages/MyTickets'
import Solutions from '../pages/Solutions'
import MyAccount from '../pages/MyAccount'
import Reports from '../pages/Reports'
import Incidents from '../pages/Incidents'
import ReportIncident from '../pages/ReportIncident'
import ProtectedRoute from './ProtectedRoute'

/**
 * Componente principal de enrutamiento de la aplicación.
 * * Gestiona la navegación jerárquica utilizando `react-router-dom`. Define:
 * - Rutas públicas (Login).
 * - Rutas protegidas bajo un `MainLayout` compartido.
 * - Una ruta de fallback para el manejo de errores 404.
 * * @component
 * @returns {JSX.Element} El árbol de rutas envuelto en un BrowserRouter.
 */
const AppRouter = () => {
  /** @type {Object} Información del usuario obtenida del contexto global. */

  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<Login />} />
        {/* La guía de usuario es de acceso público (con o sin sesión) */}
        <Route path="/ayuda" element={<HelpRoute />} />

        {/* Rutas privadas */}
        {/* Nota: Las rutas dentro de MainLayout heredan el diseño base con Sidebar y Topbar */}
        {/* ProtectedRoute exige sesión válida (y espera la hidratación) antes de
            renderizar el layout, evitando el "flash" de la app sin usuario. */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/nuevo-ticket" element={<CreateTicket />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/configuracion" element={<Settings />} />
            <Route path="/mis-tickets" element={<MyTickets />} />
            <Route path="/soluciones" element={<Solutions />} />
            <Route path="/reportes" element={<Reports />} />
            <Route path="/reportar-incidente" element={<ReportIncident />} />
            <Route path="/incidentes" element={<Incidents />} />
            <Route path="/ticket/:id" element={<ViewTicket />} />
            <Route path="/mi-cuenta" element={<MyAccount />} />
          </Route>
        </Route>
        {/* Ruta fallback */}
        {/* Captura cualquier URL no definida previamente para mostrar la página de error */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
